import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { ProductionOutputPreset } from '@paragon/contract-library';

interface ProductionOutputPresetsState {
  [productionOutputPresetGuid: string]: ProductionOutputPreset;
}

const initialState: ProductionOutputPresetsState = {};

const productionOutputPresetsSlice = createSlice({
  name: 'productionOutputPresets',
  initialState,
  reducers: {
    productionOutputPresetsLoaded: (state, action: PayloadAction<readonly ProductionOutputPreset[]>) => {
      for (const productionOutputPreset of action.payload) {
        state[productionOutputPreset.guid] = castDraft(productionOutputPreset);
      }
    },
    productionOutputPresetDeleted: (state, action: PayloadAction<string>) => {
      delete state[action.payload];
    },
  },
});

export const { productionOutputPresetsLoaded, productionOutputPresetDeleted } = productionOutputPresetsSlice.actions;
export const productionOutputPresets = productionOutputPresetsSlice.reducer;
